/**
 * 티켓 상품 서비스
 */

import apiClient from './api';
import {
  Hall,
  HallFilter,
  HallListResponse,
  Package,
  PackageFilter,
  PackageListResponse,
  ProductPrice,
  ProductPriceFilter,
  ProductPriceListResponse,
  HallMedia,
} from '../types/product';

export const productService = {
  // ========== 관 정보 관리 ==========
  
  /**
   * 관 목록 조회
   */
  async getHalls(filter: HallFilter = {}): Promise<HallListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: HallListResponse }>(`/admin/products/halls?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      halls: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 관 상세 조회
   */
  async getHall(id: number): Promise<Hall> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { hall: Hall } }>(`/admin/products/halls/${id}`);
    // return response.data.data.hall;

    throw new Error('Not implemented');
  },

  /**
   * 관 등록
   */
  async createHall(data: Partial<Hall>): Promise<Hall> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { hall: Hall } }>('/admin/products/halls', data);
    // return response.data.data.hall;

    throw new Error('Not implemented');
  },

  /**
   * 관 수정
   */
  async updateHall(id: number, data: Partial<Hall>): Promise<Hall> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { hall: Hall } }>(`/admin/products/halls/${id}`, data);
    // return response.data.data.hall;

    throw new Error('Not implemented');
  },

  /**
   * 관 삭제
   */
  async deleteHall(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/products/halls/${id}`);

    throw new Error('Not implemented');
  },

  /**
   * 관 미디어 목록 조회
   */
  async getHallMedia(hallId: number): Promise<HallMedia[]> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { media: HallMedia[] } }>(`/admin/products/halls/${hallId}/media`);
    // return response.data.data.media;

    return [];
  },

  /**
   * 관 미디어 추가
   */
  async addHallMedia(hallId: number, data: Partial<HallMedia>): Promise<HallMedia> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { media: HallMedia } }>(`/admin/products/halls/${hallId}/media`, data);
    // return response.data.data.media;

    throw new Error('Not implemented');
  },

  /**
   * 관 미디어 삭제
   */
  async deleteHallMedia(hallId: number, mediaId: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/products/halls/${hallId}/media/${mediaId}`);

    throw new Error('Not implemented');
  },

  // ========== 패키지 관리 ==========

  /**
   * 패키지 목록 조회
   */
  async getPackages(filter: PackageFilter = {}): Promise<PackageListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: PackageListResponse }>(`/admin/products/packages?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      packages: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 패키지 상세 조회
   */
  async getPackage(id: number): Promise<Package> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { package: Package } }>(`/admin/products/packages/${id}`);
    // return response.data.data.package;

    throw new Error('Not implemented');
  },

  /**
   * 패키지 등록
   */
  async createPackage(data: Partial<Package>): Promise<Package> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { package: Package } }>('/admin/products/packages', data);
    // return response.data.data.package;

    throw new Error('Not implemented');
  },

  /**
   * 패키지 수정
   */
  async updatePackage(id: number, data: Partial<Package>): Promise<Package> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { package: Package } }>(`/admin/products/packages/${id}`, data);
    // return response.data.data.package;

    throw new Error('Not implemented');
  },

  /**
   * 패키지 삭제
   */
  async deletePackage(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/products/packages/${id}`);

    throw new Error('Not implemented');
  },

  // ========== 가격 체계 관리 ==========

  /**
   * 가격 목록 조회
   */
  async getPrices(filter: ProductPriceFilter = {}): Promise<ProductPriceListResponse> {
    const params = new URLSearchParams();
    
    if (filter.owner_type) params.append('owner_type', filter.owner_type);
    if (filter.owner_id) params.append('owner_id', filter.owner_id.toString());
    if (filter.price_category) params.append('price_category', filter.price_category);
    if (filter.price_type) params.append('price_type', filter.price_type);
    if (filter.status) params.append('status', filter.status);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: ProductPriceListResponse }>(`/admin/products/prices?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      prices: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 가격 상세 조회
   */
  async getPrice(id: number): Promise<ProductPrice> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { price: ProductPrice } }>(`/admin/products/prices/${id}`);
    // return response.data.data.price;

    throw new Error('Not implemented');
  },

  /**
   * 가격 등록
   */
  async createPrice(data: Partial<ProductPrice>): Promise<ProductPrice> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { price: ProductPrice } }>('/admin/products/prices', data);
    // return response.data.data.price;

    throw new Error('Not implemented');
  },

  /**
   * 가격 수정
   */
  async updatePrice(id: number, data: Partial<ProductPrice>): Promise<ProductPrice> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { price: ProductPrice } }>(`/admin/products/prices/${id}`, data);
    // return response.data.data.price;

    throw new Error('Not implemented');
  },

  /**
   * 가격 삭제
   */
  async deletePrice(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/products/prices/${id}`);

    throw new Error('Not implemented');
  },
};

